import { render, staticRenderFns } from "./JoiningSummary.vue?vue&type=template&id=48e2f5a9&scoped=true&"
import script from "./JoiningSummary.vue?vue&type=script&lang=js&"
export * from "./JoiningSummary.vue?vue&type=script&lang=js&"
import style0 from "./JoiningSummary.vue?vue&type=style&index=0&id=48e2f5a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e2f5a9",
  null
  
)

export default component.exports